<template>
  <header id="header">
    <transition name="fade">
      <p class="header-title" v-show="!isHomePage">
        <router-link to="/">TOMOJIRO KAMIYA</router-link>
      </p>
    </transition>
    <a
      href="#"
      @click.prevent="toggleMenu"
      class="hamburger-button"
      :class="{ 'is-active': isMenuActive }"
    >
      <span></span>
      <span></span>
    </a>
  </header>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'Header',
  computed: mapState(['isMenuActive', 'isHomePage']),
  methods: {
    toggleMenu: function() {
      this.$store.commit('toggleMenuState');
    }
  }
};
</script>

<style lang="scss" scoped>
header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  z-index: 100; // vue-image-lightboxの1個上

  @include mq-up() {
    padding: 40px 4%;
  }

  @include mq-down() {
    padding: 20px 4%;
  }

  .header-title {
    margin: 0;
    padding: 0;
    color: $white;
    font-weight: bold;

    @include mq-up() {
      @include fz(32);
    }

    @include mq-down() {
      @include fz(16);
    }

    a {
      color: $white;

      @include mq-up() {
        &:hover {
          opacity: 0.5;
          color: $white;
          text-decoration: none;
        }
      }
    }
  }

  .hamburger-button {
    position: relative;
    margin-left: auto;

    @include mq-up() {
      width: 44px;
      height: 44px;
    }

    @include mq-down() {
      width: 24px;
      height: 24px;
    }

    &,
    span {
      display: inline-block;
      transition: all 0.4s;
      box-sizing: border-box;
    }
    span {
      position: absolute;
      left: 0;
      width: 100%;
      height: 3px;
      background-color: #fff;

      @include mq-up() {
        &:nth-of-type(1) {
          top: 11px;
        }

        &:nth-of-type(2) {
          top: 30px;
        }
      }

      @include mq-down() {
        &:nth-of-type(1) {
          top: 5px;
        }

        &:nth-of-type(2) {
          top: 16px;
        }
      }
    }

    &.is-active {
      span {
        @include mq-up() {
          &:nth-of-type(1) {
            transform: translate3d(0, 10px, 0) rotate(-405deg);
          }

          &:nth-of-type(2) {
            transform: translate3d(0, -9px, 0) rotate(405deg);
          }
        }

        @include mq-down() {
          &:nth-of-type(1) {
            transform: translate3d(0, 5px, 0) rotate(-405deg);
          }

          &:nth-of-type(2) {
            transform: translate3d(0, -6px, 0) rotate(405deg);
          }
        }
      }
    }
  }
}
</style>
